<div class="what-trending-detail" (mouseleave)="showShare('hide')">
    <div class="what-trending-detal-img" style="cursor: pointer;" (click)="openBlogDetail(blog)">
        <img [src]="blog && getBlogThumbnail(blog.imageList)" />
    </div>
    <div class="trending-text">
        <div class="what-trending-detail-text" style="cursor: pointer;" (click)="openBlogDetail(blog)">

          <div class="blog-list-new">
            <span class="lebal-new-2 d-lg-none d-flex" [ngStyle]="{'background-color': (categoryColor != '' && categoryColor != null) ? categoryColor : '#f38cc9'}">new</span>
          <span>{{getCategoryName(blog?.category_id)}}</span>
          </div>
          
          <span class="why-c" [ngStyle]="{'color': (categoryColor != '' && categoryColor != null) ? categoryColor : '#FF55BC'}">{{blog?.title}}</span>
          <p>{{blog?.short_description}}</p>
        </div>
        <div class="what-trending-headind">
            <div class="what-trending-headind-detail">
                <div [class]="'share-icon new-share'+blog?.id" (mouseleave)="onLeaveShare($event)">
                  <a class="blog-icon"><img (mouseover)="showShare(blog)" (click)="showShare(blog)" src="/assets/images/share-icon.svg" alt="icon">
                    <div class="blog-icon-box" (mouseleave)="showShare('hide')" [style.visibility]="share == blog?.id ? 'visible' : 'hidden'" >
                      <a (click)="clickToCopy(blog)">
                         <span><img src="/assets/images/copy-link-icon.svg" alt="icon"></span>
                         <small>Copy Link</small>
                      </a>
                      <a [href]="'https://web.whatsapp.com/send?text='+currentUrl" (click)="showShare('hide')" target="_blank">
                         <span><img src="/assets/images/whatsapp-s-icon.svg" alt="icon"></span>
                         <small>WhatsApp</small>
                      </a>
                      <a [href]="'https://www.facebook.com/sharer/sharer.php?u=' + encodeUrl" (click)="showShare('hide')" target="_blank">
                        <span><img src="./../../assets/images/facebook-icon.svg"></span>
                         <small>Facebook</small>
                      </a>
                      <a [href]="'https://twitter.com/intent/tweet?url=' + currentUrl" target="_blank" (click)="showShare('hide')">
                         <span><img src="/assets/images/twitter-new-icon.svg" alt="icon"></span>
                         <small>Twitter</small>
                      </a>
                    </div>
                  </a>
                </div>
            </div>
        </div>
    </div>
    <div class="lebal-new ">
        <span [ngStyle]="{'background-color': (categoryColor != '' && categoryColor != null) ? categoryColor : '#f38cc9'}">new</span>
    </div>
</div>